<template>
  <div class="details">
    <QS-scroller-box>
      <!-- 详情页 -->
      <div class="details_content">
        <div class="details_content_title">
          <QS-h3-title class="purchase" title="采购订单详情"></QS-h3-title>
        </div>
        <!-- tab区域 -->
        <el-tabs class="mt16"  type="card" v-model="activeName">
          <el-tab-pane
            v-for="(item, index) in allTabList"
            :key="index"
            :label="item.label"
            :name="item.name"
          >
          </el-tab-pane>
        </el-tabs>
        <!-- 订单信息 -->
        <div class="order_info" v-if="activeName==='0'">
          <div class="details_content_repeat">
            <QS-h4-title title="订单信息" />
            <div class="details_content_repeat_hundred">
              <el-form label-width="102px">
                <column-box :source="baseInfo" :list="baseInfoList">
                  <el-form-item
                    :label="'业务合同编号' + columnSeparator"
                    prop="contractAttachment"
                    class="enclosure alone"
                  >

                      <div v-if="this.baseInfo.contractNo">
                        {{ baseInfo.contractNo }}
                      </div>
                      <div v-else>--</div>

                  </el-form-item>
                  <el-form-item
                    :label="'合同附件' + columnSeparator"
                    prop="contractAttachment"
                    class="enclosure alone"
                  >

                      <div v-if="this.baseInfo.contractAttachment.length > 0">
                        <div
                          v-for="(item, index) in this.baseInfo.contractAttachment"
                          :key="'baseInfo' + index"
                          class="uptext"
                        >
                          <p
                            v-down="{ url: item.url, name: item.name }"
                            class="blue"
                          >
                            <i class="el-icon-document blue"></i>
                            {{ item.name }}
                          </p>
                        </div>
                      </div>
                      <div v-else>--</div>

                  </el-form-item>
                </column-box>
              </el-form>
            </div>
          </div>
          <!--车辆信息-->
          <car-info :detailsId="detailsId" :carInfo="carInfoList"></car-info>
          <!-- 支付信息 -->
          <pay-info :source="baseInfo"></pay-info>
        </div>
        <!-- 收付款信息 -->
        <div class="detail_aboutPay"  v-if="activeName==='1'">
          <QS-h4-title title="相关应付信息"></QS-h4-title>
          <QS-common-table
              :columns="paymentInfoHeader"
              :data="paymentInfo"
              :pagination="{}"
            ></QS-common-table>
          <QS-h4-title title="相关应收信息"></QS-h4-title>
          <QS-common-table
              :data="payfeeInfo"
              :columns="payfeeInfoHeader"
              :pagination="{}"
            ></QS-common-table>
        </div>
        <div v-if="activeName==='0'">
          <QS-h4-title title="订单关闭类型"></QS-h4-title>
          <QSColumnBox
            :source="closeTypeData"
            :list="closeTypeList"
            :separator="columnSeparator"
            label-width="140"
          ></QSColumnBox>
        </div>
      </div>
    </QS-scroller-box>
  </div>
</template>

<script>

/**
 * 2023年4月23日 删除记录
 * 1、修改修改合同信息（佳伟注释）与之相关的代码都已经删除。
 * 2、doPurchaseOrderEdit（/admin/v1/vehicle/purchase/order/edit）接口与服务端同学（长亮）确认无此接口
 * * */
import carInfo from '../components/carInfo.vue'
import payInfo from '../components/payInfo.vue'

import {
  getPurchaseDetail,
} from '@/api/domain/purchase.js'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'

export default {
  components: {
    carInfo,
    payInfo,
  },
  data() {
    return {
      activeName: '0',
      closeTypeList: [ // 订单关闭类型显示字段
        {
          key: 'closeType',
          name: '订单关闭类型',
        },
        {
          key: 'closeRemarks',
          name: '备注',
        },
      ],
      closeTypeData: { // 订单关闭类型字段数据
        closeType: '--',
        closeRemarks: '--',
      },
      allTabList: [
        { label: '订单信息', name: '0' },
        { label: '收付款信息', name: '1' },
      ],
      baseInfoList: [
        {
          key: 'id',
          name: '订单ID',
        },
        {
          key: 'purchaseMode',
          name: '采购方式',
        },
        {
          key: 'state',
          name: '订单状态',
        },
        {
          key: 'providerName',
          name: '车源方',
        },
        {
          key: 'providerId',
          name: '车源方ID',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'contractStartDate',
          name: '合同开始日期',
        },
        {
          key: 'contractEndDate',
          name: '合同结束日期',
        },
        {
          key: 'carTotalNum',
          name: '采购车辆数',
        },
        {
          key: 'deptName',
          name: '所属部门',
        },
      ],
      // 采购订单基本信息右侧内容
      baseInfo: {
        state: null,
        contractAttachment: [],
      },
      // 相关收款单tbody内容
      payfeeInfo: [],
      // 相关收款单信息
      payfeeInfoHeader: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '应收ID',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'content',
          columnProps: {
            prop: 'content',
            label: '支付内容',
          },
          getText: ({ row }) => this.formatEnumeration(this.freeTypeList)[row.content],
        },
        {
          name: 'receivableDate',
          columnProps: {
            prop: 'receivableDate',
            label: '应收日期',
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            prop: 'receivableAmount',
            label: '应收金额',
          },
          getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
        },
        {
          name: 'receivedAmount',
          columnProps: {
            prop: 'receivedAmount',
            label: '已收金额',
          },
          getText: ({ row }) => this.numberWithCommas(row.receivedAmount),
        },
        {
          name: 'remarks',
          columnProps: {
            prop: 'remarks',
            label: '备注',
          },
        },
        {
          name: 'receivableState',
          columnProps: {
            prop: 'receivableState',
            label: '收款状态',
          },
          getText: ({ row }) => selectOption.completionStatusDict[row.receivableState],
        },
        {
          name: 'completeTime',
          columnProps: {
            prop: 'completeTime',
            label: '收款完成时间',
          },
        },
      ],
      // 应付信息tbody内容
      paymentInfo: [],
      // 相关付款单信息header内容
      paymentInfoHeader: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '应付ID',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'payType',
          columnProps: {
            prop: 'payType',
            label: '支付内容',
          },
          getText: ({ row }) => this.formatEnumeration(this.freeTypeList)[row.payType],
        },
        {
          name: 'payDate',
          columnProps: {
            prop: 'payDate',
            label: '应付日期',
          },
        },
        {
          name: 'payAmount',
          columnProps: {
            prop: 'payAmount',
            label: '应付金额',
          },
          getText: ({ row }) => this.numberWithCommas(row.payAmount),
        },
        {
          name: 'paidAmount',
          columnProps: {
            prop: 'paidAmount',
            label: '已付金额',
          },
          getText: ({ row }) => this.numberWithCommas(row.paidAmount),
        },
        {
          name: 'remarks',
          columnProps: {
            prop: 'remarks',
            label: '备注',
          },
        },
        {
          name: 'payState',
          columnProps: {
            prop: 'payState',
            label: '付款状态',
          },
          getText: ({ row }) => selectOption.paymentStatusDict[row.payState],
        },
        {
          name: 'completeTime',
          columnProps: {
            prop: 'completeTime',
            label: '付款完成时间',
            width: 130,
          },
        },
      ],
      carInfoList: [],
      // 保存当前ID
      detailsId: null,
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  methods: {
    // 详情页请求数据
    async getDetails() {
      try {
        const { code, data } = await getPurchaseDetail({
          id: Number(this.detailsId),
        })
        if (code === 1) {
          this.baseInfo = { ...data.orderInfo } // 采购订单基本信息
          this.baseInfo.purchaseMode = selectOption.purchaseTypeDict[data.orderInfo.purchaseMode]
          this.carInfoList = data.carInfoList
          // 新增序号
          this.carInfoList.forEach((item, index) => {
            item.index = index + 1
            return item
          })

          if (Number(data.orderInfo.payForm) === 1) {
            this.payFormName = '一次性支付'
          } else if (Number(data.orderInfo.payForm) === 2) {
            this.payFormName = '分期付款'
          } else {
            this.payFormName = ''
          }

          this.closeTypeData = this.baseInfo
          if (Number(this.baseInfo.closeType) === 2) {
            this.closeTypeData.closeType = '提前解约'
          } else if (Number(this.baseInfo.closeType) === 3) {
            this.closeTypeData.closeType = '到期解约'
          }
          this.handle()

          this.payfeeInfo = data.receivableList || []
          this.paymentInfo = data.paymentList || []
        }
      } catch (error) {
        console.log(error)
      }
    },
    handle() {
      // 订单类型
      // const type = selectOption.typeofcontractDict[this.baseInfo.type]
      const purchaseType = selectOption.purchaseTypeDict[this.baseInfo.purchaseType]
      const state = selectOption.purchaseStateDict[this.baseInfo.state]
      const contractAttachment = this.getEchoUploadFileData(this.baseInfo.contractAttachment, true)
      this.baseInfo = {
        ...this.baseInfo,
        // type,
        purchaseType,
        state,
        contractAttachment,
      }
    },
    // 页面数据
    async getPageData() {
      await this.getDetails() // 订单详情
    },
  },
  mounted() {
    const { id } = this.$route.query
    if (!id) {
      this.$message.error('请携带必要参数')
      this.$router.go(-1)
    }
    this.detailsId = Number(id)
    this.getPageData() // 页面数据
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
.details {
  // min-height: 1422px;
  .details_content {
    .details_content_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .purchase {
        margin: 0;
      }
      h3 {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #323233;
        font-weight: 500;
        margin: 0;
      }
    }
    .details_content_repeat {
      margin-bottom: 16px;
      ::v-deep .qs-h4-container-left {
        font-size: 16px;
      }
      .details_content_repeat_hundred {
        // margin-left: 100px;
        ::v-deep .column-title {
          text-align: right;
          padding-right: 10px;
          color: #333333;
          min-width: 115px !important;
        }
        .enclosure {
          ::v-deep .el-form-item__label {
            width: 117px !important;
          }
        }
      }
    }
    // 文件图标颜色
    .uptext {
      .blue {
        color: #2e7eff;
        display: inline-block;
        margin: 0;
      }
    }
  }
  .i-title-box {
    position: relative;
    .i-title-btn {
      position: absolute;
      top: 4px;
      right: 0;
    }
  }
  .txt-right {
    text-align: right;
  }
}
</style>
